import { styled, Typography } from '@mui/material';

export const ContainerW = styled('div')`
  padding: 16px;
  border: 0px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(20px);
  position: relative;
`;

export const HeaderW = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1023px) {
    margin-bottom: 16px;
    display: none;
  }
`;

export const ActionsW = styled('div')`
  display: flex;
`;

export const Title = styled(Typography)`
  font-weight: 500;
  font-size: 18px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};

  @media (max-width: 1023px) {
    display: none;
  }
`;
